var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container move-down"},[_c('b-button',{staticClass:"login",on:{"click":_vm.goToLogin}},[_vm._v("Log In")]),_c('b-button',{staticClass:"signup",attrs:{"outlined":""},on:{"click":_vm.goToSignup}},[_vm._v("Sign Up")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }